
const clearPhone = (rawPhone) => {
    if (typeof rawPhone === 'string' && rawPhone.length > 0)
        return "+" + rawPhone.replace(/\D/g, '')

    return ''
}

const getSuitableMask = (phone, masks) => {
    const sortedMasks = [...masks]
    const phoneLength = phone.replace(/[^\d#]/g, "").length
    sortedMasks.sort((a, b) => a.replace(/[^\d#]/g, "").length - b.replace(/[^\d#]/g, "").length)
    const foundIndex = sortedMasks.findIndex(e => phoneLength <= e.replace(/[^\d#]/g, "").length)

    if (foundIndex === -1)
        return sortedMasks[sortedMasks.length-1]

    return sortedMasks[foundIndex]
}

const applyMask = (value, mask) => {
    const val = value.replace(/\D/g, '')
    if (val.length === 0) return { result: '', clearResult: '', isComplete: false }

    let i = 0;
    const result = mask.replace(/(?!\+)./g, function(a) {
        return /[#\d]/.test(a) && i < val.length ? val.charAt(i++)  : i >= val.length ? '' : a ;
    });

    const isComplete = result.length === mask.length
    const clearResult = clearPhone( result )

    return { result, clearResult, isComplete }
}

const findCountryByPhone =  (phone) => window.countryMasks.find ( c => c.phone === phone.replace ( /\s/g, '' ).slice ( 0, c.phone.length ) ) || null
const findCountryByName = (name) => window.countryMasks.find(e => e.name.toLowerCase() === name.toLowerCase())
const findCountryByCode = (code) => {
    let country = window.countryMasks.find(e => e.code.toLowerCase() === code.toLowerCase())
    return country || {code: 'GJ', name: '', phone: '+', mask: '+#############'}
}

export default function usePhoneMask( value = "", onChangeValue, countryCode = undefined, onChangeCountry ) {

    const currentCountry = React.useMemo(() => {
        if (countryCode) {
            return findCountryByCode(countryCode);
        }

        let country = window.ymaps && window.ymaps.geolocation && window.ymaps.geolocation.country ? window.ymaps.geolocation.country : '';
        if (window.isVersionEN && country === 'Russia') country = ''

        let newPhoneCode = findCountryByName(country)
        newPhoneCode = newPhoneCode ? newPhoneCode.code : '';

        return findCountryByCode(newPhoneCode)
    }, [ countryCode ])

    const clearValue = React.useMemo(
        () => clearPhone ( value ),
        [ value ])
    
    const getSuitableMasks = () => {
        return currentCountry ? [ currentCountry.mask, ...( currentCountry.additional_masks || [] ) ] : []
    }

    const suitableMask = React.useMemo(
        () => getSuitableMask ( clearValue, getSuitableMasks() ),
        [ currentCountry, clearValue ])

    const { result: maskedValue, clearResult, isComplete } = React.useMemo(
        () => applyMask ( clearValue, suitableMask ),
        [ clearValue, suitableMask ])

    const updateValue = React.useCallback(value => {
        if ( isComplete && value.length !== maskedValue.length ) {
            const newMask = getSuitableMask(value, getSuitableMasks())
            const result = applyMask(value, newMask)
            onChangeValue( result.clearResult )
            return;
        }

        const country = findCountryByPhone(value)
        if (country && country !== currentCountry) {
            onChangeCountry( country )
        }

        onChangeValue( clearPhone(value) )
        
    }, [ currentCountry, isComplete, maskedValue, onChangeValue ])

    const updateCountry = React.useCallback(code => {
        if (!code) return

        const country = findCountryByCode(code)
        if (country && country !== currentCountry) {
            onChangeCountry( country )
            onChangeValue( clearPhone(country.phone) )
        }
    }, [ currentCountry, onChangeValue ])
    
    React.useEffect(() => {
        onChangeCountry && onChangeCountry(currentCountry)
    }, [ currentCountry ])

    return [ maskedValue, clearResult, updateValue, currentCountry, updateCountry, isComplete ]
}
